// export const ENV = "DEV";
export const ENV = "PROD";

const URLS = {
  DEV: {
    BASE_HOME_URL: "http://localhost:3001",
    BASE_URL: "http://localhost:8080/api/get/",
    DASHBOAR_URL: "http://localhost:3000/login",
    BASE_URL_POST: "http://localhost:8080/api/post/",
    SIGNATURE_PAYMENTS_BASE_URL: "http://localhost:8080/payments",
    SIGNATURE_BASE_URL: "http://localhost:8080/api/v1/signature",
    BASE_ASSETS_URL:
      "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets",
    LTD_ASSETS_URL:
      "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/ltd/",
    LIFE_TIME_DEAL_PRICE_99: "price_1OUZFpLiGbRu8waGLHqHuE8A",
    LIFE_TIME_DEAL_PRICE_299: "price_1OmUanLiGbRu8waGKwpRYIFz",
    LIFE_TIME_DEAL_PRICE_499: "price_1OqWoLLiGbRu8waGJirFMwS2",
    LIFE_TIME_DEAL_PRICE_599: "price_1OqWF9LiGbRu8waGGoK6IacL",
    SECRET_DEAL_PRICE_99: "price_1Pi8SPLiGbRu8waGZC61ltAR", // TIER  - SECRET_DEAL_PRICE_99
    SECRET_DEAL_PRICE_299: "price_1Pi8SeLiGbRu8waG8ulP3ejn", // TIER  - SECRET_DEAL_PRICE_299
    SECRET_DEAL_PRICE_499: "price_1Pi8SoLiGbRu8waGf5mQzzA3", // TIER  - SECRET_DEAL_PRICE_499
    SECRET_DEAL_PRICE_UNLIMITED_99: "price_1PnFS2LiGbRu8waGlhelFbmH", // TIER - BOLOFORMS_LIFETIME_99_V1
    YEARLY_PLAN_99: "price_1OvZyPLiGbRu8waG1omrJbXp", // bizz tier 3
    YEARLY_PLAN_199: "price_1OxMRsLiGbRu8waGrIIy37EF", // bizz tier 3
    BUSINSESS_PLAN_MONTHLY_DEAL: "price_1PElC7LiGbRu8waGx3kWOxTQ", // 99/MO PLAN GIVING 50% DISCOUNT
    BUSINSESS_PLAN_YEARLY_DEAL: "price_1PElC7LiGbRu8waGx3kWOxTQ", // 999/YR PLAN GIVING AT 300 70% DICSOUNT
    ONE_DOLLAR_TRIAL_PRICE_ID: "price_1QHOgkLiGbRu8waGC8wrgccF", //   TRIAL ID
    FREELANCER_PLAN_MONTHLY_PRICE_ID: "price_1OUqsgLiGbRu8waGk8eObdee", // FREE PLAN MONTHLY PRICE ID
    FREELANCER_PLAN_ANNUALLY_PRICE_ID: "price_1Pm6c8LiGbRu8waGnOLvuz9X", // FREE PLAN ANNUALLY PRICE ID
    TEAM_PLAN_MONTHLY_PRICE_ID: "price_1Prwz6LiGbRu8waGHZVC9vlT", // TEAM PLAN MONTHLY PRICE ID
    TEAM_PLAN_ANNUALLY_PRICE_ID: "price_1PryxwLiGbRu8waGJRAgEtfv", // TEAM PLAN ANNUALLY PRICE ID
    GROWING_BUSINESS_PLAN_MONTHLY_PRICE_ID: "price_1PrwyWLiGbRu8waG4z6iibAA", // GROWING BUSINESS PLAN MONTHLY PRICE ID
    GROWING_BUSINESS_PLAN_ANNUALLY_PRICE_ID: "price_1PryznLiGbRu8waGelr3LUcb", // GROWING BUSINESS PLAN ANNUALLY PRICE ID

    PERSONAL_CONTRACT_DEAL_PRICE_99_9: "price_1PqCMBLiGbRu8waGR6BoWtpf", // PERSONAL_CONTRACT_DEAL_PRICE_99_9
    SIGNATURE_DASH_URL: "http://localhost:3000",
    CONVERSION_API: "http://localhost:8090/api",
    POSTHOG_KEY: "phc_eRGaGn6NPynRojGpYM6pFclc65laLuNcbTDjvRHIZRf",
    POSTHOG_HOST: "https://us.i.posthog.com",
  },

  PROD: {
    BASE_HOME_URL: "https://boloforms.com",
    BASE_URL: "https://main-website-backend.boloforms.com/api/get/",
    DASHBOAR_URL: "https://approval-dashboard.boloforms.com/login",
    BASE_URL_POST: "https://main-website-backend.boloforms.com/api/post/",
    SIGNATURE_PAYMENTS_BASE_URL:
      "https://signature-backend.boloforms.com/payments",
    SIGNATURE_BASE_URL:
      "https://signature-backend.boloforms.com/api/v1/signature",
    BASE_ASSETS_URL:
      "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets",
    LTD_ASSETS_URL:
      "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/ltd/",
    LIFE_TIME_DEAL_PRICE_99: "price_1OUZFpLiGbRu8waGLHqHuE8A",
    LIFE_TIME_DEAL_PRICE_299: "price_1OmUanLiGbRu8waGKwpRYIFz",
    LIFE_TIME_DEAL_PRICE_499: "price_1OqWoLLiGbRu8waGJirFMwS2",
    LIFE_TIME_DEAL_PRICE_599: "price_1OqWF9LiGbRu8waGGoK6IacL",
    SECRET_DEAL_PRICE_99: "price_1Pi8SPLiGbRu8waGZC61ltAR", // TIER  - SECRET_DEAL_PRICE_99
    SECRET_DEAL_PRICE_299: "price_1Pi8SeLiGbRu8waG8ulP3ejn", // TIER  - SECRET_DEAL_PRICE_299
    SECRET_DEAL_PRICE_499: "price_1Pi8SoLiGbRu8waGf5mQzzA3", // TIER  - SECRET_DEAL_PRICE_499
    SECRET_DEAL_PRICE_UNLIMITED_99: "price_1PnFS2LiGbRu8waGlhelFbmH", // TIER - BOLOFORMS_LIFETIME_99_V1
    YEARLY_PLAN_99: "price_1OvZyPLiGbRu8waG1omrJbXp",
    YEARLY_PLAN_199: "price_1OxMRsLiGbRu8waGrIIy37EF",
    BUSINSESS_PLAN_MONTHLY_DEAL: "price_1PNwe0LiGbRu8waG5nFXzYDa", // 99/MO PLAN GIVING 50% DISCOUNT
    BUSINSESS_PLAN_YEARLY_DEAL: "price_1PNwf7LiGbRu8waGeGrSObt2", // 999/YR PLAN GIVING AT 300 70% DICSOUNT,
    ONE_DOLLAR_TRIAL_PRICE_ID: "price_1QHOgkLiGbRu8waGC8wrgccF", //   TRIAL ID
    FREELANCER_PLAN_MONTHLY_PRICE_ID: "price_1OUqsgLiGbRu8waGk8eObdee", // FREE PLAN MONTHLY PRICE ID
    FREELANCER_PLAN_ANNUALLY_PRICE_ID: "price_1Pm6c8LiGbRu8waGnOLvuz9X", // FREE PLAN ANNUALLY PRICE ID
    TEAM_PLAN_MONTHLY_PRICE_ID: "price_1Prwz6LiGbRu8waGHZVC9vlT", // TEAM PLAN MONTHLY PRICE ID
    TEAM_PLAN_ANNUALLY_PRICE_ID: "price_1PryxwLiGbRu8waGJRAgEtfv", // TEAM PLAN ANNUALLY PRICE ID
    GROWING_BUSINESS_PLAN_MONTHLY_PRICE_ID: "price_1PrwyWLiGbRu8waG4z6iibAA", // GROWING BUSINESS PLAN MONTHLY PRICE ID
    GROWING_BUSINESS_PLAN_ANNUALLY_PRICE_ID: "price_1PryznLiGbRu8waGelr3LUcb", // GROWING BUSINESS PLAN ANNUALLY PRICE ID

    PERSONAL_CONTRACT_DEAL_PRICE_99_9: "price_1PqCMBLiGbRu8waGR6BoWtpf", // PERSONAL_CONTRACT_DEAL_PRICE_99_9
    SIGNATURE_DASH_URL: "https://signature.boloforms.com",
    CONVERSION_API: "https://convertor.boloforms.com/api",
    POSTHOG_KEY: "phc_eRGaGn6NPynRojGpYM6pFclc65laLuNcbTDjvRHIZRf",
    POSTHOG_HOST: "https://us.i.posthog.com",
  },
};

export const BASE_HOME_URL = URLS[ENV].BASE_HOME_URL;
export const BASE_URL = URLS[ENV].BASE_URL;
export const DASHBOAR_URL = URLS[ENV].DASHBOAR_URL;
export const BASE_URL_POST = URLS[ENV].BASE_URL_POST;
export const SIGNATURE_PAYMENTS_BASE_URL =
  URLS[ENV].SIGNATURE_PAYMENTS_BASE_URL;
export const SIGNATURE_BASE_URL = URLS[ENV].SIGNATURE_BASE_URL;
export const BASE_ASSETS_URL = URLS[ENV].BASE_ASSETS_URL;
export const LTD_ASSETS_URL = URLS[ENV].LTD_ASSETS_URL;
export const LIFE_TIME_DEAL_PRICE_99 = URLS[ENV].LIFE_TIME_DEAL_PRICE_99;
export const YEARLY_PLAN_99 = URLS[ENV].YEARLY_PLAN_99;
export const YEARLY_PLAN_199 = URLS[ENV].YEARLY_PLAN_199;
export const LIFE_TIME_DEAL_PRICE_299 = URLS[ENV].LIFE_TIME_DEAL_PRICE_299;
export const LIFE_TIME_DEAL_PRICE_499 = URLS[ENV].LIFE_TIME_DEAL_PRICE_499;
export const LIFE_TIME_DEAL_PRICE_599 = URLS[ENV].LIFE_TIME_DEAL_PRICE_599;
export const SECRET_DEAL_PRICE_99 = URLS[ENV].SECRET_DEAL_PRICE_99;
export const SECRET_DEAL_PRICE_299 = URLS[ENV].SECRET_DEAL_PRICE_299;
export const SECRET_DEAL_PRICE_499 = URLS[ENV].SECRET_DEAL_PRICE_499;
export const SECRET_DEAL_PRICE_UNLIMITED_99 =
  URLS[ENV].SECRET_DEAL_PRICE_UNLIMITED_99;
export const BUSINSESS_PLAN_MONTHLY_DEAL =
  URLS[ENV].BUSINSESS_PLAN_MONTHLY_DEAL;
export const BUSINSESS_PLAN_YEARLY_DEAL = URLS[ENV].BUSINSESS_PLAN_YEARLY_DEAL;
export const PERSONAL_CONTRACT_DEAL_PRICE_99_9 =
  URLS[ENV].PERSONAL_CONTRACT_DEAL_PRICE_99_9;
export const SIGNATURE_DASH_URL = URLS[ENV].SIGNATURE_DASH_URL;
export const CONVERSION_API = URLS[ENV].CONVERSION_API;
export const ONE_DOLLAR_TRIAL_PRICE_ID = URLS[ENV].ONE_DOLLAR_TRIAL_PRICE_ID;
export const FREELANCER_PLAN_MONTHLY_PRICE_ID =
  URLS[ENV].FREELANCER_PLAN_MONTHLY_PRICE_ID;
export const FREELANCER_PLAN_ANNUALLY_PRICE_ID =
  URLS[ENV].FREELANCER_PLAN_ANNUALLY_PRICE_ID;
export const TEAM_PLAN_MONTHLY_PRICE_ID = URLS[ENV].TEAM_PLAN_MONTHLY_PRICE_ID;
export const TEAM_PLAN_ANNUALLY_PRICE_ID =
  URLS[ENV].TEAM_PLAN_ANNUALLY_PRICE_ID;
export const GROWING_BUSINESS_PLAN_MONTHLY_PRICE_ID =
  URLS[ENV].GROWING_BUSINESS_PLAN_MONTHLY_PRICE_ID;
export const GROWING_BUSINESS_PLAN_ANNUALLY_PRICE_ID =
  URLS[ENV].GROWING_BUSINESS_PLAN_ANNUALLY_PRICE_ID;
export const FIREBASE_CONFIG_SIGNATURE = {
  apiKey: "AIzaSyCaiH6ahboH2jhaWaMU4dGFVgn_YmdCsiI",
  authDomain: "boloforms-signature.firebaseapp.com",
  projectId: "boloforms-signature",
  storageBucket: "boloforms-signature.appspot.com",
  messagingSenderId: "980217179187",
  appId: "1:980217179187:web:6014724409a35d13364746",
  measurementId: "G-KPY51MSHG9",
};
export const POSTHOG_KEY = URLS[ENV].POSTHOG_KEY;
export const POSTHOG_HOST = URLS[ENV].POSTHOG_HOST;
